export default __webpack_public_path__ + "static/media/art-landing.53d12d1d.png";